import { render } from "./PreisminderungEingabe.vue?vue&type=template&id=6252e20a"
import script from "./PreisminderungEingabe.vue?vue&type=script&lang=js"
export * from "./PreisminderungEingabe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__